export default {
  settings: 'Definições',
  storefront: 'Loja online',
  media: 'Multimédia',
  style: 'Estilo',
  scripts: 'Scripts',
  no_google_place: {
    title: 'A empresa não está ligada a nenhuma localização Google',
    description: 'Por favor, ligue a empresa a uma localização Google',
  },
};
